import axios from 'axios'
import { reduceParams } from 'utils/helpers'
import { ThunkAction } from 'store/types'
import { DEPARTMENT_ID } from '../../constants'
import * as actions from './actions'
import { finishLoading, startLoading } from '../loading/actions'
import { handleErrorMessageAlert } from 'components/UI/Alert'

export const fetchRelationships = (): ThunkAction => {
  return async dispatch => {
    dispatch(actions.relationshipRequest())

    try {
      const resp = await axios.get('/relationships')

      dispatch(actions.relationshipSuccess(resp.data))
    } catch (err) {
      dispatch(actions.relationshipFail(err))
    }
  }
}

export const fetchGenders = (): ThunkAction => {
  return async dispatch => {
    dispatch(actions.genderRequest())

    try {
      const resp = await axios.get('/genders')

      dispatch(actions.genderSuccess(resp.data))
    } catch (err) {
      dispatch(actions.genderFail(err))
    }
  }
}

export const fetchPatients = (search?: string): ThunkAction => {
  return async dispatch => {
    dispatch(actions.patientsRequest())

    try {
      let params: {} | { [p: string]: any } = {
        carrierName: search
      }
      params = reduceParams(params)

      const resp = await axios.get(`/public/insuranceCarriers?locationId=${DEPARTMENT_ID}`, { params })

      dispatch(actions.patientsSuccess(resp.data))
    } catch (err) {
      dispatch(actions.patientsFail(err))
    }
  }
}

export const fetchAppointments = (search?: string): ThunkAction => {
  return async dispatch => {
    dispatch(actions.appointmentsRequest())
    try {
      let params: {} | { [p: string]: any } = {
        description: search,
        departmentId: `${DEPARTMENT_ID}`
      }
      params = reduceParams(params)

      const resp = await axios.get(`/appointmentTypes`, { params })

      dispatch(actions.appointmentsSuccess(resp.data))
    } catch (err) {
      dispatch(actions.appointmentsFail(err))
    }
  }
}

export const fetchPhysicians = (): ThunkAction => {
  return async dispatch => {
    dispatch(actions.physiciansRequest())
    try {
      const resp = await axios.get(`/public/physicians?locationId=${DEPARTMENT_ID}`)
      dispatch(actions.physiciansSuccess(resp.data))
    } catch (err) {
      dispatch(actions.physiciansFail(err))
    }
  }
}

export const fetchServiceAreas = (id: number): ThunkAction => {
  return async dispatch => {
    dispatch(actions.serviceAreasRequest())
    try {
      const resp = await axios.get(`/serviceAreas/${id}?facility=${DEPARTMENT_ID}`)
      dispatch(actions.serviceAreasSuccess(resp.data))
    } catch (err) {
      dispatch(actions.serviceAreasFail(err))
    }
  }
}

export const fetchCpt4Codes = (insuranceCarrierId?: number, size?: number, text?: string): ThunkAction => {
    return async dispatch => {
      dispatch(actions.getCpt4Request())
      try {
        let resp
        if (text) {
          resp = await axios.get(`/public/cpt4?locationId=${DEPARTMENT_ID}&insuranceCarrierId=${insuranceCarrierId}&keyWord=${text}&size=${size}`)
        } else {
          resp = await axios.get(`/public/cpt4?locationId=${DEPARTMENT_ID}&insuranceCarrierId=${insuranceCarrierId}&size=${size}`)
        }
        dispatch(actions.getCpt4Success(resp.data))
      } catch (err) {
        dispatch(actions.getCpt4Fail(err))
      }
    }
  }

export const fetchAllCpt4Codes = (insuranceCarrierId?: number, size?: number, page?: number, text?: string): ThunkAction => {
  return async dispatch => {
    console.log("fetchCpt4Code",insuranceCarrierId )

    if (!size) {
        size = 300
    }
    // @ts-ignore
    dispatch(startLoading())    
    dispatch(actions.getCpt4Request())
    //@ts-ignore
    dispatch(startLoading())
    try {
      let resp
      if (text && insuranceCarrierId) {
        resp = await axios.get(`/cpt4?locationId=${DEPARTMENT_ID}&insuranceCarrierId=${insuranceCarrierId}&keyWord=${text}&size=${size}`)
      } else if (insuranceCarrierId) {
        resp = await axios.get(`/cpt4?locationId=${DEPARTMENT_ID}&insuranceCarrierId=${insuranceCarrierId}&size=${size}`)
      } else {
        resp = await axios.get(`/cpt4?locationId=${DEPARTMENT_ID}${text ? `&keyWord=${text}` : ''}&size=${size}&page=${page}`)
      }
      dispatch(actions.getCpt4Success(resp.data))
    } catch (err) {
      dispatch(actions.getCpt4Fail(err))
    }
    //@ts-ignore
    dispatch(finishLoading())
  }
}

export const createCpt4 = (cpt4: { code: string; description: string; }): ThunkAction => {
  return async dispatch => {
    dispatch(actions.createCpt4Request())
    //@ts-ignore
    dispatch(startLoading())
    try {
      const resp = await axios.post('/cpt4', {
          ...reduceParams(cpt4)
      })
      if (resp.status === 200) {
        dispatch(actions.createCpt4Success(resp.data))
      } else {
        if (resp && resp.data && resp.data.errorMessage) {
          handleErrorMessageAlert(resp.data.errorMessage)
          dispatch(actions.createCpt4Fail(resp.data.errorMessage))
        }
      }
    } catch (err) {
        if (err.response && err.response.data && err.response.data.errorMessage) {
            handleErrorMessageAlert(
              err.response && err.response.data && err.response.data.errorMessage
            )
        }
        dispatch(actions.createCpt4Fail(err))
    }
    //@ts-ignore
    dispatch(finishLoading())
  }
}

export const updateCpt4 = (cpt4: { id: number, code: string; description: string; }): ThunkAction => {
  return async dispatch => {
    dispatch(actions.updateCpt4Request())
    //@ts-ignore
    dispatch(startLoading())
    console.log(cpt4)
    try {
      const resp = await axios.put(`/cpt4/${cpt4.id}`, {
          ...reduceParams(cpt4)
      })
      if (resp.status === 200) {
        dispatch(actions.updateCpt4Success(resp.data))
      } else {
        if (resp && resp.data && resp.data.errorMessage) {
          handleErrorMessageAlert(resp.data.errorMessage)
          dispatch(actions.updateCpt4Fail(resp.data.errorMessage))
        }
      }
    } catch (err) {
        if (err.response && err.response.data && err.response.data.errorMessage) {
            handleErrorMessageAlert(
              err.response && err.response.data && err.response.data.errorMessage
            )
        }
      dispatch(actions.updateCpt4Fail(err))
    }
    //@ts-ignore
    dispatch(finishLoading())
  }
}

export const deleteCpt4 = (cpt4Id: number): ThunkAction => {
  return async dispatch => {
    dispatch(actions.deleteCpt4Request())
    //@ts-ignore
    dispatch(startLoading())
    try {
      const resp = await axios.delete(`/cpt4/${cpt4Id}`)
      if (resp.status === 200) {
        dispatch(actions.deleteCpt4Success(resp.data))
      } else {
        if (resp && resp.data && resp.data.errorMessage) {
          handleErrorMessageAlert(resp.data.errorMessage)
          dispatch(actions.deleteCpt4Fail(resp.data.errorMessage))
        }
      }
    } catch (err) {
        if (err.response && err.response.data && err.response.data.errorMessage) {
            handleErrorMessageAlert(
              err.response && err.response.data && err.response.data.errorMessage
            )
        }
      dispatch(actions.deleteCpt4Fail(err))
    }
    //@ts-ignore
    dispatch(finishLoading())
  }
}

export const fetchConfiguration = (): ThunkAction => {
  return async dispatch => {
    dispatch(actions.configurationRequest())
    try {
      const resp = await axios.get(`/configuration?departmentId=${DEPARTMENT_ID}`)
      dispatch(actions.configurationSuccess(resp.data))
    } catch (err) {
      dispatch(actions.configurationFail(err))
    }
  }
}

const generateLogo = async () =>
  await axios.get(`/configuration/logo?departmentId=${DEPARTMENT_ID}`, {
    responseType: 'blob'
  })

const getDataLink = (data: Blob) => {
  const url = window.URL.createObjectURL(data)
  // const link: any = document.createElement('a')
  // link.href = url
  // link.target = '_blank'

  return url
}

const generateHeaderLogo = async () =>
  await axios.get(`/configuration/logoHeader?departmentId=${DEPARTMENT_ID}`, {
    responseType: 'blob'
  })


export const fetchConfigurationLogo = (): ThunkAction => {
  return async dispatch => {
    dispatch(actions.configurationLogoRequest())
    try {
      const resp = await generateLogo()
      const link = getDataLink(resp.data)
      dispatch(actions.configurationLogoSuccess(link))
    } catch (err) {
      dispatch(actions.configurationLogoFail(err))
    }
  }
}

export const fetchConfigurationLogoHeader = (): ThunkAction => {
  return async dispatch => {
    dispatch(actions.configurationLogoRequest())
    try {
      const resp = await generateHeaderLogo()
      const link = getDataLink(resp.data)
      console.log(link)
      dispatch(actions.configurationLogoHeaderSuccess(link))
    } catch (err) {
      dispatch(actions.configurationHeaderLogoFail(err))
    }
  }
}
